import React from 'react';
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Box,
  Divider,
  Hidden,
} from '@material-ui/core';
import ShowMoreText from 'react-show-more-text';
import GetStartedBtn from 'components/ListYourBike/GetStartedBtn';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginTop: theme.spacing(13),
    paddingBottom: theme.spacing(13),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(16.75),
      marginTop: theme.spacing(18),
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(5.5),
      paddingBottom: theme.spacing(10),
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    marginBottom: theme.spacing(4.5),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
      marginBottom: theme.spacing(7.5),
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(10.25),
    },
  },
  partTitle: {
    fontSize: theme.typography.pxToRem(24),
    textAlign: 'center',
    [theme.breakpoints.only('sm')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  partDesc: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.grey[300],
    marginTop: theme.spacing(1.5),
    textAlign: 'center',
    [theme.breakpoints.only('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  partDivider: {
    marginTop: theme.spacing(6.25),
    marginBottom: theme.spacing(1.25),
    height: theme.spacing(0.625),
    backgroundColor: theme.palette.grey[300],
    width: '20%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  getStartedBox: {
    marginTop: theme.spacing(9),
    textAlign: 'center',
    letterSpacing: theme.typography.pxToRem(0.5),
    lineHeight: theme.typography.pxToRem(24),
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(4.5),
    },
  },
  detailsText: {
    marginTop: theme.spacing(4.25),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(8.75),
    },
    [theme.breakpoints.up('lg')]: {
      textAlign: 'left',
      marginTop: theme.spacing(6.25),
    },
  },
  readMore: {
    textDecoration: 'underline',
    color: theme.palette.secondary.main,
  },
}));

const WhyEagleShare = ({ i18n }) => {
  const classes = useStyles();

  return (
    <>
      <Container maxWidth="xl" classes={{ root: classes.mainContainer }}>
        <Typography variant="h2" classes={{ root: classes.title }}>
          {i18n('fe_es_why_eagleShare:title')}
        </Typography>

        <Grid container alignItems="stretch" spacing={8}>

          <Grid item xs={12} lg={4}>
            <Typography variant="h3" classes={{ root: classes.partTitle }}>
              {i18n('fe_es_why_eagleShare:parts.title1')}
            </Typography>
            <Typography classes={{ root: classes.partDesc }}>
              {i18n('fe_es_why_eagleShare:parts.desc1')}
            </Typography>
            <Hidden lgUp>
              <Divider classes={{ root: classes.partDivider }} />
            </Hidden>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Typography variant="h3" classes={{ root: classes.partTitle }}>
              {i18n('fe_es_why_eagleShare:parts.title2')}
            </Typography>
            <Typography classes={{ root: classes.partDesc }}>
              {i18n('fe_es_why_eagleShare:parts.desc2')}
            </Typography>
            <Hidden lgUp>
              <Divider classes={{ root: classes.partDivider }} />
            </Hidden>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Typography variant="h3" classes={{ root: classes.partTitle }}>
              {i18n('fe_es_why_eagleShare:parts.title3')}
            </Typography>
            <Typography classes={{ root: classes.partDesc }}>
              {i18n('fe_es_why_eagleShare:parts.desc3')}
            </Typography>

          </Grid>
        </Grid>
        <Hidden smDown>
          <Typography classes={{ root: classes.detailsText }}>
            {i18n('fe_es_why_eagleShare:passionate_about_bikes')}
          </Typography>
        </Hidden>
        <Hidden mdUp>
          <ShowMoreText
            lines={6}
            more={i18n('fe_es_why_eagleShare:read_more')}
            less={i18n('fe_es_why_eagleShare:read_less')}
            className={classes.detailsText}
            anchorClass={classes.readMore}
            expanded={false}
          >
            {i18n('fe_es_why_eagleShare:passionate_about_bikes')}
          </ShowMoreText>
        </Hidden>

        <Box className={classes.getStartedBox}>
          <GetStartedBtn i18n={i18n} />
        </Box>
      </Container>
    </>
  );
};

export default WhyEagleShare;
